import { useEffect, useRef, useState } from "react";

const POPOVER_WIDTH = 224;
const GAP = 8;

function useFixedPopover() {
  const triggerRef = useRef(null);
  const [popoverPos, setPopoverPos] = useState(null);

  useEffect(() => {
    if (!popoverPos) return;
    function onScroll() {
      setPopoverPos(null);
    }
    window.addEventListener("scroll", onScroll, true);
    return () => window.removeEventListener("scroll", onScroll, true);
  }, [popoverPos]);

  function showPopover() {
    if (!triggerRef.current) return;
    const rect = triggerRef.current.getBoundingClientRect();
    let side = "right";
    let left = rect.right + GAP;
    if (left + POPOVER_WIDTH > window.innerWidth - GAP) {
      side = "left";
      left = rect.left - POPOVER_WIDTH - GAP;
    }
    const top = Math.max(rect.top - 4, GAP);
    setPopoverPos({ left, top, side });
  }

  function hidePopover() {
    setPopoverPos(null);
  }

  return { triggerRef, popoverPos, showPopover, hidePopover };
}

export default useFixedPopover;